import { HeaderPanel } from '../../HeaderPanel';
import { headerPanelOptions } from './panelSettings';
import './Description.less';
import { HtmlRenderer } from 'components/HtmlRenderer/HtmlRenderer';

const detailsHistoryClass = 'dp-entitydetails-description';
interface DescriptionPanelProps {
  title?: string;
  description?: string;
}

export function DescriptionPanel({ description, title }: DescriptionPanelProps) {
  return (
    <HeaderPanel {...headerPanelOptions('primary', title || 'Description')}>
      {description && <HtmlRenderer className={`${detailsHistoryClass}__text`} html={description} />}
    </HeaderPanel>
  );
}
